"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitDays = exports.waitHours = exports.waitMinutes = exports.waitSeconds = void 0;
const waitSeconds = (seconds) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => resolve(), 1000 * seconds);
    });
};
exports.waitSeconds = waitSeconds;
const waitMinutes = (minues) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => resolve(), 60 * 1000 * minues);
    });
};
exports.waitMinutes = waitMinutes;
const waitHours = (hours) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => resolve(), 60 * 1000 * hours);
    });
};
exports.waitHours = waitHours;
const waitDays = (days) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => resolve(), 60 * 1000 * days);
    });
};
exports.waitDays = waitDays;
